import script from "./DownloadModelCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadModelCard.vue?vue&type=script&setup=true&lang=js"

import "./DownloadModelCard.vue?vue&type=style&index=0&id=2374b06e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2374b06e"]])

export default __exports__